import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AuthState } from 'src/app/store/auth/auth.reducer';
import { actionPasswordResetRequest } from 'src/app/store/auth/auth.actions';

@Component({
    selector: 'app-password-reset-request',
    templateUrl: './password-reset-request.component.html',
    styleUrls: ['./password-reset-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordResetRequestComponent implements OnInit {
  form = new UntypedFormGroup({
    email: new UntypedFormControl('')
  });

  formState = this.store.select(s => s.auth.passwordResetRequestForm);

  constructor(private store: Store<{ auth: AuthState }>) {}

  ngOnInit() {}

  submit() {
    this.store.dispatch(
      actionPasswordResetRequest({
        email: this.form.value.email
      })
    );
  }
}
